<template>
  <div>
    <div class="table-responsive">
      <b-table
        :items="broker_offers"
        :fields="broker_offers_fields"
        :tbody-tr-class="rowClass"
      >
        <template #cell(delievery_price)="data">
          {{ data.value }} {{ showCurrency(data.item.delivery_price_currency) }}
        </template>
        <template #cell(view)="data">
          <button class="btn btn-link" @click="openOffer(data.item)">
            <i class="fa fa-search"></i>
          </button>
        </template>
        <template #cell(choose)="data">
          <label>
            <input
              type="radio"
              :id="'select' + data.item.id"
              name="courier"
              :disabled="!data.item.is_accepted || !is_owner || is_selected"
              :value="data.item.ID"
              v-model="current_courier_offer_id"
            />
            {{ $t("message.contracts.select_radio_button") }}
          </label>
        </template>
        <template #cell(offer_date)="data">
          {{ data.value.split(" ")[0] }}
        </template>
        <template #cell(date_of_delivery)="data">
          <span v-if="data.value !== ''">{{ momentum(data.value) }}</span>
        </template>
      </b-table>
    </div>
    <div v-if="!is_selected">
      <button
        class="btn btn-outline-success btn-sm"
        v-if="can_request"
        @click="createRequest"
        v-b-modal.modal-new
      >
        {{ $t("message.contracts.broker_request") }}
      </button>
    </div>
    <button
      class="btn btn-info btn-sm float-right"
      v-if="is_owner && current_courier_offer_id != '' && !is_selected"
      @click="selectCourier"
    >
      {{ $t("message.contracts.select_broker") }}
    </button>
    <b-modal
      id="modal-new"
      hide-footer
      :title="
        $t('message.contracts.broker_request_modal_title') +
        ' ' +
        offer.contract_id
      "
      size="lg"
    >
      <div class="row">
        <div class="col-6">
          <strong>
            {{ $t("message.contracts.delivery_request_from") }}:
            <span v-if="is_view == true">{{
              offer.countragent_1.org_name
            }}</span>
            <span v-else>{{ current_company.org_name }}</span>
          </strong>
        </div>
        <div class="col-12">
          <b-table
            :items="is_view ? offer.products : products"
            :fields="product_fields"
          >
            <template #cell(attis_cg_TNVED)="data">
              {{ data.value.value }}
            </template>
            <template #cell(attis_cg_price)="data">
              {{ data.value }} {{ currency.display_text }}
            </template>
          </b-table>
        </div>
        <div class="col-6 col-lg-3">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required' /*, $v.offer.from_address.$error?'has-danger label-floating':''*/,
            ]"
          >
            <input
              type="number"
              :disabled="offer.is_accepted"
              class="form-control"
              v-model="offer.epi_price"
              :placeholder="$t('message.contracts.epi_price')"
              autocomplete="off"
              style="cursor: auto"
              id="epi_price"
            />
            <label for="epi_price" class="form-label-group-label shorter">{{
              $t("message.contracts.epi_price")
            }}</label>
            <!-- <label v-if="form_error && !$v.offer.from_address.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
        </div>
        <div class="col-6 col-lg-3">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <v-select-popup
              type="currency"
              v-model="offer.epi_price_currency"
              :placeholder="$t('message.contracts.epi_price_currency')"
              :disabled="offer.is_accepted"
            />

            <!-- <v-select :disabled="offer.is_accepted" id="epi_price_currency" :options="currencies" label="display_text" :class="['form-control', typeof offer.epi_price_currency !== 'undefined' && offer.epi_price_currency.value!==''?'vs--selected':'']" v-model="offer.epi_price_currency" :placeholder="$t('message.contracts.epi_price_currency')" @focus="epi_price_currency_focused=true" @blur="epi_price_currency_focused=false" @search=fetchCurrencies></v-select> -->
            <!-- <label for="epi_price_currency" class="form-label-group-label shorter">{{$t('message.contracts.epi_price_currency')}}</label> -->
          </span>
        </div>
        <div class="col-6 col-lg-3">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required' /*, $v.offer.from_address.$error?'has-danger label-floating':''*/,
            ]"
          >
            <input
              type="number"
              :disabled="offer.is_accepted"
              class="form-control"
              v-model="offer.td_price"
              :placeholder="$t('message.contracts.td_price')"
              autocomplete="off"
              style="cursor: auto"
              id="td_price"
            />
            <label for="td_price" class="form-label-group-label shorter">{{
              $t("message.contracts.td_price")
            }}</label>
            <!-- <label v-if="form_error && !$v.offer.from_address.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
        </div>
        <div class="col-6 col-lg-3">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <v-select-popup
              type="currency"
              v-model="offer.td_price_currency"
              :placeholder="$t('message.contracts.td_price_currency')"
              :disabled="offer.is_accepted"
            />

            <!-- <v-select :disabled="offer.is_accepted" id="td_price_currency" :options="currencies" label="display_text" :class="['form-control', typeof offer.td_price_currency !== 'undefined' && offer.td_price_currency.value!==''?'vs--selected':'']" v-model="offer.td_price_currency" :placeholder="$t('message.contracts.td_price_currency')" @focus="td_price_currency_focused=true" @blur="td_price_currency_focused=false" @search=fetchCurrencies></v-select> -->
            <!-- <label for="td_price_currency" class="form-label-group-label shorter">{{$t('message.contracts.td_price_currency')}}</label> -->
          </span>
        </div>
        <div class="col-12">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required',
              delivery_term_focused
                ? 'focused'
                : '' /*, $v.offer.type_of_movement.$error?'has-danger label-floating':''*/,
            ]"
          >
            <v-select-popup
              type="delivery_term"
              v-model="offer.delivery_term"
              :placeholder="$t('message.contracts.delivery_term')"
              :disabled="is_view"
            />

            <!-- <v-select :disabled="is_view" id="delivery_term" :options="delivery_terms" label="display_text" :class="['form-control', typeof offer.delivery_term !== 'undefined' && offer.delivery_term.value!==''?'vs--selected':'']" v-model="offer.delivery_term" :placeholder="$t('message.contracts.delivery_term')" @focus="delivery_term_focused=true" @blur="delivery_term_focused=false"></v-select> -->
            <!-- <label for="delivery_term" v-if="!is_view" class="form-label-group-label shorter">{{$t('message.contracts.delivery_term')}}</label> -->
            <!-- <label v-if="form_error && !$v.offer.type_of_movement.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
        </div>
        <div class="col-12">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <textarea
              :disabled="is_view && is_offer_mine(offer)"
              class="form-control"
              v-model="offer.comments"
              :placeholder="$t('message.contracts.comments')"
              autocomplete="off"
              style="cursor: auto"
              id="comments"
            ></textarea>
            <label for="comments" class="form-label-group-label shorter">{{
              $t("message.contracts.comments")
            }}</label>
          </span>
        </div>
        <div class="col-12" v-if="is_offer_mine(offer)">
          <h5>{{ $t("message.contracts.brokers") }}</h5>
          <b-table :items="couriers" :fields="couriers_fields">
            <template #cell(invite)="data">
              <label
                ><input
                  type="checkbox"
                  :disabled="is_view"
                  v-model="offer.invites"
                  :value="data.item.org_code"
                />
                {{ $t("message.contracts.invite") }}</label
              >
            </template>
          </b-table>
        </div>
        <div
          class="d-block files-block col-12"
          v-if="!is_view || (is_view && files.length > 0)"
        >
          <h5>{{ $t("message.contracts.attachements") }}</h5>
          <div class="file-o" v-for="(file, index) in files" :key="index">
            <div class="row">
              <div class="col-11">
                <a target="_blank" :href="'/Picture/GetTxtFile/' + file.id"
                  >{{ file.name }} <i class="fas fa-arrow-down"></i
                ></a>
              </div>
              <div class="col-1" v-if="!is_view">
                <button
                  class="btn btn-sm btn-link text-danger"
                  @click="deleteFile(file, index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
          <div v-if="!is_view">
            <div v-for="(file, index) in files_att" class="row" :key="index">
              <div class="col-11">
                <input
                  type="file"
                  @change="attachFile($event, index)"
                  class="form-control"
                />
              </div>
              <div class="col-1">
                <button
                  class="btn btn-sm btn-link text-danger"
                  @click="removeFile(index)"
                >
                  &times;
                </button>
              </div>
            </div>
          </div>
          <div v-if="!is_view">
            <button
              class="btn btn-sm btn-outline-success"
              @click="addAttachement"
            >
              {{ $t("message.contracts.add_attachement") }}
            </button>
            <br />
            <small
              ><i>{{
                $t("message.contracts.couriers_attahments_info")
              }}</i></small
            >
          </div>
        </div>
        <div class="col-12 text-right" v-if="!is_view">
          <button class="btn btn-sm btn-success" @click="submit">
            {{ $t("message.save_and_send") }}
          </button>
        </div>
      </div>
      <div style="margin-left: -24px; margin-right: -24px">
        <div
          class="courier_contract bg-success-light"
          style="padding: 24px"
          v-if="
            (offer.is_accepted && is_owner) ||
            (offer.is_accepted &&
              offer.countragent_2.org_code == current_company.org_code)
          "
        >
          <h4>{{ $t("message.contracts.broker_contract") }}</h4>
          <div class="row">
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.bc_number')"
              >
                <input
                  :disabled="true"
                  type="text"
                  class="form-control"
                  v-model="offer.bc_number"
                  :placeholder="$t('message.contracts.bc_number')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_number"
                />
                <label for="bc_number" class="form-label-group-label shorter">{{
                  $t("message.contracts.bc_number")
                }}</label>
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.bc_city')"
              >
                <input
                  :disabled="true"
                  type="text"
                  class="form-control"
                  v-model="offer.bc_city"
                  :placeholder="$t('message.contracts.bc_city')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_city"
                />
                <label for="bc_city" class="form-label-group-label shorter">{{
                  $t("message.contracts.bc_city")
                }}</label>
              </span>
            </div>
            <div class="col-md-6">
              <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                <input
                  :disabled="true"
                  type="text"
                  class="form-control"
                  v-model="offer.bc_date"
                  :placeholder="$t('message.contracts.offer.bc_date')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_date"
                />
                <label
                  for="bc_date"
                  v-if="offer.bc_date != ''"
                  class="form-label-group-label shorter topped"
                  >{{ $t("message.contracts.bc_date") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.bc_agreement')"
              >
                <input
                  :disabled="true"
                  type="text"
                  class="form-control"
                  v-model="offer.bc_agreement"
                  :placeholder="$t('message.contracts.bc_agreement')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_agreement"
                />
                <label
                  for="bc_agreement"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.bc_agreement") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.bc_penalty_amount')"
              >
                <input
                  :disabled="true"
                  type="text"
                  class="form-control"
                  v-model="offer.bc_penalty_amount"
                  :placeholder="$t('message.contracts.bc_penalty_amount')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_penalty_amount"
                />
                <label
                  for="bc_penalty_amount"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.bc_penalty_amount") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                <v-select-popup
                  type="currency"
                  v-model="offer.bc_currency"
                  :placeholder="$t('message.contracts.bc_currency')"
                  :disabled="trye"
                />

                <!-- <v-select :disabled="true" id="bc_currency" :options="currencies" label="display_text" :class="['form-control', typeof offer.bc_currency !== 'undefined' && offer.bc_currency.value!==''?'vs--selected':'']" v-model="offer.bc_currency" :placeholder="$t('message.contracts.bc_currency')" @focus="bc_currency_focused=true" @blur="bc_currency_focused=false" @search="fetchCurrencies"></v-select> -->
                <!-- <label for="bc_currency" class="form-label-group-label shorter">{{$t('message.contracts.bc_currency')}}</label> -->
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.bc_trial_city')"
              >
                <input
                  :disabled="true"
                  type="text"
                  class="form-control"
                  v-model="offer.bc_trial_city"
                  :placeholder="$t('message.contracts.bc_trial_city')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_trial_city"
                />
                <label
                  for="bc_trial_city"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.bc_trial_city") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="[
                  'bmd-form-group mb-2 d-block form-label-group',
                  language_focused ? 'focused' : '',
                ]"
              >
                <v-select-popup
                  type="language"
                  v-model="offer.bc_trial_language"
                  :placeholder="
                    $t(
                      'message.contracts.attis_contract_conditions_contract_language',
                    )
                  "
                  :disabled="true"
                />
                <!-- <v-select :disabled="true" id="bc_trial_language" :options="languages" label="display_text" :class="['form-control ', typeof offer.bc_trial_language !== 'undefined' && offer.bc_trial_language.value!==''?'vs--selected':'']" v-model="offer.bc_trial_language" :placeholder="$t('message.contracts.attis_contract_conditions_contract_language')" @focus="language_focused=true" @blur="language_focused=false"></v-select> -->
                <!-- <label for="bc_trial_language" class="form-label-group-label shorter">{{$t('message.contracts.bc_trial_language')}}</label> -->
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <pdf
              :document="offer"
              :goods="[]"
              :user_id="0"
              :doc_id="offer.contract_id"
              :doc_additional="{}"
              source="broker_contract"
            ></pdf>
            <!-- <button class="btn btn-success" @click="acceptOffer(pre_accept_offer)">{{$t('message.ok')}}</button>
                        <button class="btn btn-danger" @click="unPreAcceptOffer(offer)">{{$t('message.cancel')}}</button> -->
          </div>
        </div>

        <div
          class="courier_contract bg-success-light"
          style="padding: 24px"
          v-if="pre_accept"
        >
          <h4>{{ $t("message.contracts.broker_contract") }}</h4>
          <div class="row">
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.bc_number')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.bc_number"
                  :placeholder="$t('message.contracts.bc_number')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_number"
                />
                <label for="bc_number" class="form-label-group-label shorter">{{
                  $t("message.contracts.bc_number")
                }}</label>
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.bc_city')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.bc_city"
                  :placeholder="$t('message.contracts.bc_city')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_city"
                />
                <label for="bc_city" class="form-label-group-label shorter">{{
                  $t("message.contracts.bc_city")
                }}</label>
              </span>
            </div>
            <div class="col-md-6">
              <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                <!-- <b-form-datepicker :locale="locale" v-model="pre_accept_offer_fields.bc_date" :placeholder="$t('message.contracts.bc_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false"></b-form-datepicker>
                            <label for="bc_date" v-if="pre_accept_offer_fields.bc_date!=''"  class="form-label-group-label shorter topped">{{$t('message.contracts.bc_date')}}</label> -->

                <datepicker
                  value-type="YYYY-MM-DD"
                  format="DD.MM.YYYY"
                  @focus="pre_accept_offer_fields.bc_date = ' '"
                  @blur="
                    pre_accept_offer_fields.bc_date == ' '
                      ? (pre_accept_offer_fields.bc_date = '')
                      : (pre_accept_offer_fields.bc_date =
                          pre_accept_offer_fields.bc_date)
                  "
                  inputClass="form-control"
                  :disabled="is_field_readonly"
                  v-model="pre_accept_offer_fields.bc_date"
                  :placeholder="$t('message.contracts.bc_date')"
                  :inputAttr="{ id: 'bc_date' }"
                />
                <label
                  for="bc_date"
                  class="form-label-group-label shorter"
                  :class="
                    pre_accept_offer_fields.bc_date != '' &&
                    pre_accept_offer_fields.bc_date != null
                      ? 'topped'
                      : ''
                  "
                  >{{ $t("message.contracts.bc_date") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.bc_agreement')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.bc_agreement"
                  :placeholder="$t('message.contracts.bc_agreement')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_agreement"
                />
                <label
                  for="bc_agreement"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.bc_agreement") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.bc_penalty_amount')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.bc_penalty_amount"
                  :placeholder="$t('message.contracts.bc_penalty_amount')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_penalty_amount"
                />
                <label
                  for="bc_penalty_amount"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.bc_penalty_amount") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                <v-select-popup
                  type="currency"
                  :placeholder="$t('message.contracts.bc_currenct')"
                  v-model="pre_accept_offer_fields.bc_currency"
                />

                <!-- <v-select id="bc_currency" :options="currencies" label="display_text" :class="['form-control', typeof pre_accept_offer_fields.bc_currency !== 'undefined' && pre_accept_offer_fields.bc_currency.value!==''?'vs--selected':'']" v-model="pre_accept_offer_fields.bc_currency" :placeholder="$t('message.contracts.bc_currency')" @focus="bc_currency_focused=true" @blur="bc_currency_focused=false" @search="fetchCurrencies"></v-select> -->
                <!-- <label for="bc_currency" class="form-label-group-label shorter">{{$t('message.contracts.bc_currency')}}</label> -->
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.bc_trial_city')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.bc_trial_city"
                  :placeholder="$t('message.contracts.bc_trial_city')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="bc_trial_city"
                />
                <label
                  for="bc_trial_city"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.bc_trial_city") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="[
                  'bmd-form-group mb-2 d-block form-label-group',
                  language_focused ? 'focused' : '',
                ]"
              >
                <v-select-popup
                  type="language"
                  :placeholder="
                    $t(
                      'message.contracts.attis_contract_conditions_contract_language',
                    )
                  "
                  v-model="pre_accept_offer_fields.bc_trial_language"
                />

                <!-- <v-select  id="bc_trial_language" :options="languages" label="display_text" :class="['form-control ', typeof pre_accept_offer_fields.bc_trial_language !== 'undefined' && pre_accept_offer_fields.bc_trial_language.value!==''?'vs--selected':'']" v-model="pre_accept_offer_fields.bc_trial_language" :placeholder="$t('message.contracts.attis_contract_conditions_contract_language')" @focus="language_focused=true" @blur="language_focused=false"></v-select> -->
                <!-- <label for="bc_trial_language" class="form-label-group-label shorter">{{$t('message.contracts.bc_trial_language')}}</label> -->
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <button class="btn btn-sm btn-success" @click="acceptOffer()">
              {{ $t("message.ok") }}
            </button>
            <button
              class="btn btn-sm btn-danger"
              @click="unPreAcceptOffer(offer)"
            >
              {{ $t("message.cancel") }}
            </button>
          </div>
        </div>
        <div
          class="col-12 d-flex justify-content-between"
          v-if="
            i_can_accept_or_decline && offer.is_accepted !== true && !pre_accept
          "
        >
          <button class="btn btn-sm btn-success" @click="preAcceptOffer()">
            {{ $t("message.contracts.offer_accept") }}
          </button>
          <button class="btn btn-sm btn-danger" @click="declineOffer(offer)">
            {{ $t("message.contracts.offer_decline") }}
          </button>
        </div>
        <div v-if="offer.is_accepted && !checkSigned(offer) && is_selected">
          <button
            class="btn btn-sm btn-success float-left"
            @click="submit_and_sign_dialog()"
          >
            {{ $t("message.contracts.submit_and_sign_button") }}
          </button>
        </div>
        <!-- <div class="col-12 d-flex justify-content-between" v-if="is_view && !is_owner && is_broker">
                    <button class="btn btn-success" @click="acceptOffer(offer)">{{$t('message.contracts.offer_accept')}}</button>
                    <button class="btn btn-danger" @click="declineOffer(offer)">{{$t('message.contracts.offer_decline')}}</button>
                </div> -->
      </div>
    </b-modal>
    <b-modal
      id="modal-select-ecp-type"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-sm btn-outline-success btn-round"
          @click="submit_and_sign()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-sm btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-sm btn-success btn-round"
          :class="['btn btn-success btn-round', loading_sign ? 'pl-5' : '']"
          :disabled="sign_with_code_code.length == 0"
          @click="sign_with_code_phase2()"
        >
          <div class="loading my-1 loading-button" v-if="loading_sign"></div>
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-sm btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
// import { required } from 'vuelidate/lib/validators'
export default {
  data() {
    return {
      sign_with_code_code: "",
      loading_sign: false,
      is_selected: false,
      show_code_sign_type: false,
      selected_bin: "",
      can_request: false,
      current_company: {
        org_code: "",
        org_name: "",
      },
      form_error: false,
      can_add: true,
      current_courier_offer_id: 0,
      broker_offers: [],
      pre_accept: false,
      pre_accept_offer_fields: {
        broker_offer_id: "",
        contract_id: "",
        comment: "",
        bc_number: "",
        bc_city: "",
        bc_date: "",
        bc_agreement: "",
        bc_penalty_amount: "",
        bc_currency: "",
        bc_trial_city: "",
        bc_trial_language: "",
        owner: "",
        broker: "",
      },
      td_price_currency_focused: false,
      epi_price_currency_focused: false,
      bc_currency_focused: false,
      delivery_term_focused: false,
      currencies: [],
      files_att: [],
      files: [],
      is_view: false,
      offer: {
        countragent_1: { org_name: "", org_code: "" },
        delivery_term: { value: "", display_text: "" },
        epi_price: "",
        td_price: "",
        epi_price_currency: { value: "" },
        td_price_currency: { value: "" },
        comments: "",
        invites: [],
      },
      hazard_classes: [
        {
          value: "class1",
          display_text: this.$t("message.contracts.hazard_class1"),
        },
        {
          value: "class2",
          display_text: this.$t("message.contracts.hazard_class2"),
        },
        {
          value: "class3",
          display_text: this.$t("message.contracts.hazard_class3"),
        },
        {
          value: "class4",
          display_text: this.$t("message.contracts.hazard_class4"),
        },
        {
          value: "class5",
          display_text: this.$t("message.contracts.hazard_class5"),
        },
        {
          value: "class6",
          display_text: this.$t("message.contracts.hazard_class6"),
        },
        {
          value: "class7",
          display_text: this.$t("message.contracts.hazard_class7"),
        },
        {
          value: "class8",
          display_text: this.$t("message.contracts.hazard_class8"),
        },
        {
          value: "class9",
          display_text: this.$t("message.contracts.hazard_class9"),
        },
        {
          value: "class0",
          display_text: this.$t("message.contracts.hazard_class0"),
        },
      ],
      delivery_types: [
        {
          value: "auto",
          display_text: this.$t("message.contracts.delivery_type_auto"),
        },
        {
          value: "railway",
          display_text: this.$t("message.contracts.delivery_type_railway"),
        },
        {
          value: "avia",
          display_text: this.$t("message.contracts.delivery_type_avia"),
        },
        {
          value: "sea",
          display_text: this.$t("message.contracts.delivery_type_sea"),
        },
        {
          value: "post",
          display_text: this.$t("message.contracts.delivery_type_post"),
        },
      ],
      broker_offers_fields: [
        {
          key: "view",
          label: this.$t("message.contracts.view"),
        },
        {
          key: "countragent_2.org_name",
          label: this.$t("message.contracts.broker"),
        },
        {
          key: "epi_price",
          label: this.$t("message.contracts.epi_price"),
        },
        {
          key: "td_price",
          label: this.$t("message.contracts.td_price"),
        },
        {
          key: "offer_date",
          label: this.$t("message.contracts.offer_date"),
        },
        {
          key: "choose",
          label: this.$t("message.contracts.choose_broker"),
          class: "text-right",
        },
      ],
      couriers: [],
      couriers_fields: [
        {
          key: "org_name",
          label: this.$t("message.contracts.courier_name"),
        },
        {
          key: "org_code",
          label: this.$t("message.contracts.courier_code"),
        },
        {
          key: "invite",
          label: this.$t("message.contracts.invite"),
        },
      ],
      delivery_terms: [],
      language_focused: false,

      languages: [
        { value: "ru", display_text: this.$t("message.contracts.russian") },
        { value: "en", display_text: this.$t("message.contracts.english") },
        { value: "cn", display_text: this.$t("message.contracts.chinese") },
      ],
      product_fields: [
        {
          key: "attis_cg_TNVED",
          label: this.$t("message.contracts.product_sku"),
          sortable: true,
        },
        {
          key: "attis_cg_good_name",
          label: this.$t("message.contracts.product_title"),
          sortable: true,
        },

        // {
        // 	key: 'ved',
        // 	label: this.$t('message.contracts.product_ved'),
        // 	sortable: true
        // },
        // {
        // 	key: 'attis_cg_quantity',
        // 	label: this.$t('message.contracts.product_qty'),
        // 	sortable: true
        // },
        // {
        // 	key: 'units',
        // 	label: this.$t('message.contracts.product_units'),
        // 	sortable: true
        // },
        {
          key: "attis_cg_price",
          label: this.$t("message.contracts.product_unit_price"),
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    this.load();
    this.fetchCurrencies("");
    this.fetchDeliveryTerms("");
    this.loadCouriers();
    this.loadCompanyName();
    this.$root.$on("show-courier-offer", () => {
      console.log($this.$route.params.id);
    });
  },
  props: {
    contract_id: String,
    // can_add: Boolean,
    products: Array,
    currency: Object,
    is_deal: Boolean,
    is_owner: Boolean,
    roles: Array,
    is_full: Boolean,
  },
  computed: {
    i_can_accept_or_decline() {
      if (!this.is_broker) {
        console.log("is broker false1");
        return false;
      }
      if (
        typeof this.offer.countragent_2 != "undefined" &&
        typeof this.offer.countragent_2.org_code != "undefined" &&
        typeof this.current_company != "undefined" &&
        typeof this.current_company.org_code != "undefined"
      ) {
        if (
          this.offer.countragent_2.org_code.trim() ==
          this.current_company.org_code.trim()
        ) {
          return true;
        }
      }
      return false;
    },
    is_broker() {
      var result = false;
      this.roles.forEach((role) => {
        if (role.toLowerCase() == "broker") result = true;
      });
      return result;
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  methods: {
    fetchDeliveryTerms(search, loading) {
      this.getLibrary("delivery_term", search, 100);
    },
    showCurrency(currency) {
      // return ''
      // console.log(this.currencies)
      var index = this.currencies.findIndex((i) => i.value == currency);
      if (index > -1) return this.currencies[index].display_text;
      return "";
    },
    checkSigned(offer) {
      if (this.is_owner && offer.is_signed_by_owner) return true;
      if (this.is_broker && offer.is_signed_by_broker) return true;

      return false;
    },
    submit_and_sign() {
      this.loading = true;
      axios
        .get(
          window.base +
            "/Contract/getbrokerofferxml?contract_id=" +
            this.contract_id,
        )
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            // window.getKeyInfo('PKCS12', "getKeyInfoBack");
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            // console.log(result)
            // window.signXml("PKCS12", "SIGNATURE", this.xml, ()=>{
            // });
            // return true;
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                console.log(result);
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      fd.append("contract_id", this.contract_id);
                      fd.append("signature", value);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/contract/AddBrokerContractSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.contract_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type");
                          this.$bvModal.hide("modal-new");
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.contract_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type");
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.contract_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                window.webSocket.removeEventListener("message", {});
                window.webSocket.close();
              }
            }
          };
        });
    },
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        this.loading_sign = true;
        axios
          .get(
            window.base +
              "/document/getbrokerofferxml?contract_id=" +
              this.contract_id,
          )
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.contract_id);
                fd.append("signature", response.data);
                fd.append("type", "code");
                axios
                  .post(
                    window.base + "/document/AddBrokerContractSignature",
                    fd,
                  )
                  .then(() => {
                    this.loading = false;
                    this.loading_sign = false;
                    this.load();
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type");
                    this.$bvModal.hide("modal-new");
                  })
                  .catch((e) => {
                    this.loading = false;
                    this.loading_sign = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type");
                  });
              });
          });
      }
    },
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    recalculate_selected() {
      if (this.selected_bin !== "") {
        if (this.broker_offers.length > 0) {
          this.broker_offers.forEach((i) => {
            if (i.countragent_2.org_code == this.selected_bin)
              i.is_selected = true;
          });
        }
      }
    },
    rowClass(item) {
      if (this.is_selected) {
        if (item.is_selected) return "bg-success-light";
        else {
          if (item.is_accepted) return "text-line-through bg-success-light";
          else return "text-line-through";
        }
      } else if (item.is_accepted) return "bg-success-light";
      return "";
    },
    /**
     * Hides the form to input all details of the transport contract
     */
    unPreAcceptOffer() {
      this.pre_accept = false;
    },
    /**
     * Displays the form to input all details of the transport contract
     */
    preAcceptOffer() {
      this.pre_accept = true;
    },
    acceptOffer() {
      var fd = new FormData();
      fd.append("org_id", this.current_company.org_code);
      this.pre_accept_offer_fields.broker_offer_id = this.offer.ID;
      this.pre_accept_offer_fields.comment = this.offer.comments;
      this.pre_accept_offer_fields.owner = this.offer.countragent_1.org_code;
      this.pre_accept_offer_fields.broker = this.current_company.org_code;
      this.pre_accept_offer_fields.contract_id = this.contract_id;
      fd.append("td_price", this.offer.td_price);
      fd.append("td_price_currency", this.offer.td_price_currency.value);
      fd.append("epi_price", this.offer.epi_price);
      fd.append("epi_price_currency", this.offer.epi_price_currency.value);
      // fd.append('contract', this.pre_accept_offer_fields)
      for (var i in this.pre_accept_offer_fields) {
        if (typeof this.pre_accept_offer_fields[i] == "object")
          fd.append(i, this.pre_accept_offer_fields[i].value);
        else fd.append(i, this.pre_accept_offer_fields[i]);
      }
      axios
        .post(window.base + "/contract/acceptBrokerOffer", fd)
        .then((response) => {
          if (response.data.status == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.broker_offer-ok"),
              timeout: 5000,
            }).show();
            this.$bvModal.hide("modal-new");
            offer.is_accepted = true;
            this.load();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.broker_offer-nok"),
              timeout: 5000,
            }).show();
          }
        });
    },
    declineOffer(offer) {
      var fd = new FormData();
      fd.append("broker_offer_id", offer.ID);
      fd.append("comment", offer.comments);
      fd.append("org_id", this.current_company.org_code);
      axios
        .post(window.base + "/contract/declineBrokerOffer", fd)
        .then((response) => {
          if (response.data.status == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.decline-broker_offer-ok"),
              timeout: 5000,
            }).show();
            this.$bvModal.hide("modal-new");
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.decline-broker_offer-nok"),
              timeout: 5000,
            }).show();
          }
        });
    },
    is_offer_mine(offer) {
      return offer.countragent_1.org_code == this.current_company.org_code;
    },
    can_request_for_broker() {
      axios
        .get(
          window.base +
            "/contract/CanRequestForBroker?contract_id=" +
            this.contract_id,
        )
        .then((response) => {
          console.log("can request");
          var tmp = false;
          if (response.data.result == "True") {
            tmp = true;
          }
          this.can_request = tmp && this.is_owner;
        });
    },
    loadCompanyName() {
      if (this.$store.state.firmfull == false) {
        axios.get(window.base + "/document/getfirmfull").then((response) => {
          this.$store.commit("load_firm", response.data);
          this.current_company = response.data.organizations;
        });
      } else {
        this.current_company = this.$store.state.firmfull.organizations;
      }
    },
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type");
    },
    submit() {
      // this.$v.$touch()
      // if(this.$v.offer.$invalid) {
      // this.form_error = true
      // setTimeout(()=>{
      // $('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
      // }, 100)
      /*}else*/ {
        this.form_error = false;
        var fd = new FormData();
        for (var i in this.offer) {
          if (typeof this.offer[i] == "object")
            if (i == "invites") fd.append(i, this.offer[i]);
            else if (i == "countragent_1") fd.append(i, this.offer[i].org_code);
            else fd.append(i, this.offer[i].value);
          else fd.append(i, this.offer[i]);
        }
        for (var i in this.files_att) {
          fd.append("file[" + i + "]", this.files_att[i]);
        }
        this.products.forEach((product, index) => {
          fd.append(
            "product[" + index + "].attis_cg_good_name",
            product.attis_cg_good_name,
          );
          fd.append(
            "product[" + index + "].attis_cg_TNVED",
            product.attis_cg_TNVED.value,
          );
          fd.append(
            "product[" + index + "].attis_cg_quantity",
            product.attis_cg_quantity,
          );
          fd.append(
            "product[" + index + "].attis_cg_measures",
            product.attis_cg_measures.value,
          );
          fd.append(
            "product[" + index + "].attis_cg_price",
            product.attis_cg_price,
          );
        });
        fd.append("contract_id", this.contract_id);
        axios
          .post(window.base + "/contract/createBrokerRequest", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.data.status == "ok") {
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.create-broker_offer-ok"),
                timeout: 5000,
              }).show();
              this.$bvModal.hide("modal-new");
              this.load();
            } else {
              new Noty({
                theme: "light",
                type: "error",
                text: this.$root.$t("message.message.create-broker_offer-nok"),
                timeout: 5000,
              }).show();
            }
          });
      }
    },
    loadCouriers() {
      axios.get(window.base + "/contract/getbrokers").then((response) => {
        this.couriers = response.data;
      });
    },
    attachFile(event, index) {
      if (typeof event.target.files[0] !== "undefined")
        this.files_att[index] = event.target.files[0];
    },
    removeFile(index) {
      this.files_att.splice(index, 1);
    },
    addAttachement() {
      this.files_att.push("");
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
          // this.$data[var_name] = response.data
        });
    },
    fetchCurrencies() {
      this.getLibrary("currency", "", 100);
    },
    selectCourier() {
      var fd = new FormData();
      fd.append("broker_offer_id", this.current_courier_offer_id);
      fd.append("contract_id", this.contract_id);
      fd.append(
        "broker_id",
        this.broker_offers[
          this.broker_offers.findIndex(
            (offer) => offer.ID == this.current_courier_offer_id,
          )
        ].countragent_2.org_code,
      );
      axios
        .post(window.base + "/contract/selectBrokerOffer", fd)
        .then((response) => {
          if (response.data.status == 200) {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.select-broker_offer-ok"),
              timeout: 5000,
            }).show();
            // this.is_selected = true;
            // //offer.is_selected = true;
            // this.selected_bin = this.broker_offers[this.broker_offers.findIndex(offer=>offer.ID==this.current_courier_offer_id)].countragent_2.org_code
            // this.broker_offers[this.broker_offers.findIndex(offer=>offer.ID==this.current_courier_offer_id)].is_selected = true;
            this.load();
            this.$bvModal.hide("modal-new");
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.select-broker_offer-nok"),
              timeout: 5000,
            }).show();
          }
        });
    },
    createRequest() {
      this.is_view = false;
      // this.offer = {
      //     countragent_1: {...this.current_company},
      //     type_of_movement: {value: '', display_text: '',},
      //     from_address: '',
      //     to_address: '',
      //     weight: '',
      //     volume: '',
      //     delivery_price_currency: {value: ''},
      //     date_of_load: '',
      //     date_of_delivery: '',
      //     hazard_class: {value: '',},
      //     comments: '',
      //     invites: []
      // }
      this.$set(this, "offer", {
        countragent_1: { ...this.current_company },
        delivery_term: { value: "", display_text: "" },
        epi_price: "",
        td_price: "",
        epi_price_currency: { value: "" },
        td_price_currency: { value: "" },
        comments: "",
        invites: [],
      });
    },
    openOffer(offer) {
      // this.offer = {...offer}
      this.$set(this, "offer", offer);
      setTimeout(() => {
        this.offer.epi_price_currency =
          this.currencies[
            this.currencies.findIndex(
              (i) => i.value == offer.epi_price_currency,
            )
          ];
        this.offer.td_price_currency =
          this.currencies[
            this.currencies.findIndex((i) => i.value == offer.td_price_currency)
          ];
        this.offer.delivery_term =
          this.delivery_terms[
            this.delivery_terms.findIndex((i) => i.value == offer.delivery_term)
          ];
        this.offer.bc_currency =
          this.currencies[
            this.currencies.findIndex((i) => i.value == offer.bc_currency)
          ];
        this.offer.bc_trial_language =
          this.languages[
            this.languages.findIndex((i) => i.value == offer.bc_trial_language)
          ];
        //this.offer.bc_date = this.momentum(offer.bc_date);
      }, 500);
      this.is_view = true;

      this.$set(this, "files", offer.files);
      this.offer.products.forEach((product, i) => {
        axios
          .get(
            window.base +
              "/library/tnved?code=" +
              product.attis_cg_TNVED +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            this.$set(
              this.offer.products[i],
              "attis_cg_TNVED",
              response.data[0],
            );
          });
      });
      axios
        .get(
          window.base +
            "/library?type=org_type&qty=" +
            100000 +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var org_types = response.data;
          axios
            .get(
              window.base +
                "/document/getFirmbyBin?bin=" +
                offer.countragent_1.org_code,
            )
            .then((res1) => {
              this.offer.org1 = res1.data;
              var tmp1 = org_types.filter((obj) => {
                return obj.value == this.offer.org1.organizations.org_type;
              });
              if (typeof tmp1[0] !== "undefined")
                this.offer.org1.organizations.org_type = tmp1[0].display_text;
              axios
                .get(
                  window.base +
                    "/document/getFirmbyBin?bin=" +
                    offer.countragent_2.org_code,
                )
                .then((res) => {
                  this.offer.org2 = res.data;
                  var tmp2 = org_types.filter((obj) => {
                    return obj.value == this.offer.org2.organizations.org_type;
                  });
                  if (typeof tmp2[0] !== "undefined")
                    this.offer.org2.organizations.org_type =
                      tmp2[0].display_text;
                });
            });
        });

      this.offer.invites = offer.invites;
      if (typeof offer != "object") this.offer.invites = [];

      this.$bvModal.show("modal-new");
      // console.log(this.offer, this.is_view)
      // console.log(this.offer.countragent_1.org_code, this.current_company.org_code, this.offer.countragent_1.org_code == this.current_company.org_code)
    },
    momentum(date) {
      return moment(date).format("DD.MM.Y");
    },
    load() {
      this.can_request_for_broker();
      var httpString = "";
      console.log("is_full");
      console.log(this.is_full);
      if (this.is_full) {
        httpString = window.base + "/contract/getAllBrokerOffers";
        console.log("this is full offer");
      } else {
        httpString =
          window.base +
          "/contract/getBrokerOffers?contract_id=" +
          this.contract_id;
        console.log("broker offer by contract");
      }
      axios
        .get(httpString)
        .then((response) => {
          this.broker_offers = response.data;
          if (!this.is_full) {
            axios
              .get(
                window.base +
                  "/contract/selectedBrokerOffer?contract_id=" +
                  this.contract_id,
              )
              .then((res) => {
                if (typeof res.data.organization_name !== "undefined") {
                  if (res.data.organization_name === null)
                    this.is_selected = false;
                  else {
                    this.is_selected = true;
                    this.selected_bin = res.data.org_code;
                    this.recalculate_selected();
                  }
                } else {
                  this.is_selected = false;
                }
              });
          }
          //console.log(this.i_can_accept_or_decline());
          if (this.$route.name == "broker-single") {
            let offer =
              this.broker_offers[
                this.broker_offers.findIndex(
                  (i) => i.ID == this.$route.params.oid,
                )
              ];
            this.openOffer(offer);
          }
        })
        .catch((ex) => {
          // this.broker_offers = [
          //     {
          //         "ID": "21341234123",
          //         "is_accepted": false,
          //         "countragent_1": {
          //             "org_code": "12341234",
          //             "org_name": "Ципа"
          //         },
          //         "countragent_2": {
          //             "org_code": "341341",
          //             "org_name": "Липа"
          //         },
          //         "products": [],
          //         "epi_price": "10",
          //         "epi_currency": "978",
          //         "td_price": 100,
          //         "td_currency": 978,
          //         "delivery_term": 'DAF',
          //         "delivery_price_currency": "978",
          //         "offer_date": "20.09.2020",
          //         "comments": ""
          //     },
          //     {
          //        "ID": "21341234123",
          //         "is_accepted": false,
          //         "countragent_1": {
          //             "org_code": "12341234",
          //             "org_name": "Ципа"
          //         },
          //         "countragent_2": {
          //             "org_code": "341341",
          //             "org_name": "Липа"
          //         },
          //         "products": [],
          //         "epi_price": "10",
          //         "epi_currency": "978",
          //         "td_price": 100,
          //         "td_currency": 978,
          //         "delivery_term": 'DAF',
          //         "delivery_price_currency": "978",
          //         "offer_date": "20.09.2020",
          //         "comments": ""
          //     },
          // ]
        });
    },
  },
  /*validations:{
        offer: {
            type_of_movement:{
                required
            },	
            from_address: {
                required
            },
            to_address: {
                required
            },
            weight: {
                require
            },
            volume: {
                require
            },
            delivery_price: {
                require
            },
            hazard_class: {
                require
            }
        },
    }*/
};
</script>
